module.exports = __webpack_public_path__ + "f3cb2799b6380e79da6f0c129f3e7778.svg";